/* ModaVena Atelier — minimal progressive enhancement.
   No dependencies. Everything degrades to working HTML without JS:
   the cart drawer is a real <form> against /cart, the product form is a real
   product form, and every panel is reachable by its own URL. */
(function () {
  'use strict';

  var overlay = document.getElementById('mv-overlay');
  var CART_SECTION = 'cart-drawer';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  var lastOpener = null;   // para devolver el foco al cerrar
  var busyCount = 0;       // varias peticiones a la vez: solo el último libera
  var pending = Promise.resolve();  // cola: las mutaciones del carrito van en serie
  var refreshAbort = null; // cancela un refresco en vuelo que ya no interesa

  /* ---------------------------------------------------------------- panels */

  function panelOf(id) { return document.getElementById(id); }

  function openPanel(panel, opener) {
    if (!panel) return;
    var already = panel.getAttribute('aria-hidden') === 'false';
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mv-locked');
    if (opener) lastOpener = opener;
    if (already) return;                       // no robar el foco en cada refresco
    var first = panel.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function closePanels() {
    var open = document.querySelectorAll('.mv-panel[aria-hidden="false"]');
    if (!open.length) return false;
    // Devolver el foco ANTES de ocultar: un subárbol aria-hidden no puede contenerlo.
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    open.forEach(function (p) { p.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mv-locked');
    lastOpener = null;
    return true;
  }

  function cartPanel() { return panelOf('mv-cart-panel'); }
  function cartOpen() {
    var p = cartPanel();
    return !!p && p.getAttribute('aria-hidden') === 'false';
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mv-open]');
    if (opener) {
      event.preventDefault();
      var panel = panelOf(opener.getAttribute('data-mv-open'));
      openPanel(panel, opener);
      // El drawer se sirvió con la página y puede estar obsoleto: refrescar al abrirlo.
      if (panel && panel.hasAttribute('data-mv-cart-drawer')) queue(refreshCart);
      return;
    }
    if (event.target.closest('[data-mv-close]') || event.target === overlay) {
      event.preventDefault();
      closePanels();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (closePanels()) event.preventDefault();
      return;
    }
    if (event.key !== 'Tab') return;
    // Focus trap: con un diálogo modal abierto, Tab no debe salirse a la página.
    var panel = document.querySelector('.mv-panel[aria-hidden="false"]');
    if (!panel) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    } else if (!panel.contains(document.activeElement)) {
      event.preventDefault(); first.focus();
    }
  });

  /* ------------------------------------------------------------------ cart */

  function setBusy(on) {
    busyCount += on ? 1 : -1;
    if (busyCount < 0) busyCount = 0;
    var host = document.getElementById('shopify-section-' + CART_SECTION);
    if (host) host.style.opacity = busyCount > 0 ? '0.55' : '';
  }

  function showCartError(message) {
    var box = document.querySelector('[data-mv-cart-error]');
    if (!box) return;
    if (!message) { box.hidden = true; box.textContent = ''; return; }
    box.textContent = message;
    box.hidden = false;
  }

  /** Todas las mutaciones del carrito en serie: pulsar + tres veces rápido no debe
      lanzar tres POST concurrentes cuyo orden de respuesta decida el resultado. */
  function queue(fn) {
    pending = pending.then(fn, fn);
    return pending;
  }

  /* Re-render del servidor: precios, descuentos y totales siempre autoritativos. */
  function refreshCart(keepOpen) {
    var wasOpen = cartOpen() || keepOpen;
    var panel = cartPanel();
    var scrollTop = panel ? panel.scrollTop : 0;
    var activeKey = document.activeElement && document.activeElement.getAttribute
      ? document.activeElement.getAttribute('data-mv-line-qty')
      : null;

    if (refreshAbort) refreshAbort.abort();
    refreshAbort = typeof AbortController === 'function' ? new AbortController() : null;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + CART_SECTION, {
      headers: { 'Accept': 'application/json' },
      signal: refreshAbort ? refreshAbort.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[CART_SECTION];
        var host = document.getElementById('shopify-section-' + CART_SECTION);
        if (!html || !host) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + CART_SECTION) || doc.body.firstElementChild;
        if (!fresh) return;
        host.innerHTML = fresh.innerHTML;

        var next = cartPanel();
        if (next) {
          if (wasOpen) openPanel(next, lastOpener);
          next.scrollTop = scrollTop;                      // no saltar al principio
          if (activeKey) {
            var again = next.querySelector('[data-mv-line-qty="' + activeKey + '"]');
            if (again) again.focus();                      // devolver el foco a la misma línea
          }
        }
        syncCount();
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;          // lo cancelamos nosotros
      });
  }

  function syncCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-mv-open="mv-cart-panel"]').forEach(function (el) {
          var base = el.getAttribute('data-mv-cart-label') || 'Cart';
          el.setAttribute('aria-label', cart.item_count ? base + ' (' + cart.item_count + ')' : base);
        });
      })
      .catch(function () {});
  }

  /* Añadir al carrito sin salir de la página, y mostrar el drawer. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    setBusy(true);
    showCartError('');

    var reached = false;   // ¿llegó la petición al servidor?
    queue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          reached = true;
          return r.text().then(function (text) {
            var body = null;
            try { body = JSON.parse(text); } catch (e) { /* respuesta no JSON */ }
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            // El artículo NO se añadió: mostrar el motivo, nunca reenviar el formulario.
            showCartError((res.body && (res.body.description || res.body.message)) ||
                          'This item could not be added to your bag.');
            openPanel(cartPanel(), null);
            return;
          }
          return refreshCart(true);
        })
        .catch(function () {
          // Reenviar SOLO si el servidor no llegó a recibir nada. Si ya respondió,
          // reenviar añadiría el artículo por segunda vez.
          if (!reached) { form.submit(); return; }
          showCartError('Something went wrong. Open your bag to check it.');
        })
        .then(function () {
          if (button) button.disabled = false;
          setBusy(false);
        });
    });
  });

  /** /cart/change.js acepta la clave de línea en `id`: es estable aunque el HTML
      del panel esté obsoleto, al revés que el índice de posición. */
  function changeLine(key, quantity) {
    return queue(function () {
      setBusy(true);
      showCartError('');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          return r.text().then(function (text) {
            var body = null;
            try { body = JSON.parse(text); } catch (e) {}
            if (!r.ok) {
              // 422 = más unidades de las que hay; 404 = la línea ya no existe.
              showCartError((body && (body.description || body.message)) ||
                            'That quantity is not available.');
            }
            return refreshCart(true);
          });
        })
        .catch(function () { showCartError('Could not update your bag. Please try again.'); })
        .then(function () { setBusy(false); });
    });
  }

  /* Eliminar: el href sigue funcionando sin JS. */
  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-mv-line-remove]');
    if (!remove || !remove.closest('[data-mv-cart-drawer]')) return;
    event.preventDefault();
    changeLine(remove.getAttribute('data-mv-line-remove'), 0);
  });

  /* Botón "update" del drawer: con JS no debe recargar y sacarte del panel. */
  document.addEventListener('click', function (event) {
    var update = event.target.closest('[data-mv-update]');
    if (!update || !update.closest('[data-mv-cart-drawer]')) return;
    event.preventDefault();
    var form = update.closest('form');
    if (!form) return;
    var updates = {};
    form.querySelectorAll('[data-mv-line-qty]').forEach(function (input) {
      var n = parseInt(input.value, 10);
      if (!isNaN(n)) updates[input.getAttribute('data-mv-line-qty')] = n;
    });
    queue(function () {
      setBusy(true);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { return refreshCart(true); })
        .catch(function () { showCartError('Could not update your bag. Please try again.'); })
        .then(function () { setBusy(false); });
    });
  });

  /* Botones +/−. En el drawer hablan con el carrito; en la ficha solo mueven el input. */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-mv-step]');
    if (!step) return;
    var wrap = step.closest('[data-mv-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '0', 10);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;
    var next = current + parseInt(step.getAttribute('data-mv-step'), 10);
    if (next < min) next = min;
    input.value = next;

    var key = input.getAttribute('data-mv-line-qty');
    if (key && step.closest('[data-mv-cart-drawer]')) {
      changeLine(key, next);
    } else {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* Escribir una cantidad a mano en el drawer. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-mv-line-qty]')) return;
    if (!input.closest('[data-mv-cart-drawer]')) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || input.value.trim() === '') {
      // Campo vacío: no vale como "0", eso borraría la línea sin que nadie lo pida.
      refreshCart(true);
      return;
    }
    changeLine(input.getAttribute('data-mv-line-qty'), n);
  });

  /* ---------------------------------------------------------------- gallery */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-mv-thumb]');
    if (!thumb) return;
    event.preventDefault();
    var gallery = thumb.closest('[data-mv-gallery]');
    var main = gallery && gallery.querySelector('[data-mv-main-image]');
    if (!main) return;
    var src = thumb.getAttribute('data-mv-thumb');
    if (!src) return;
    var srcset = thumb.getAttribute('data-mv-thumb-srcset');
    main.src = src;
    // Mantener el srcset: borrarlo servía la imagen grande también en móvil.
    if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
    gallery.querySelectorAll('[data-mv-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });
})();
